<script setup>
import moment from "moment";
moment.locale("id");
</script>

<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <h2 class="text-red-600 text-3xl font-inter font-bold">
          Report CoC (Certificate of CMS Compliance)
        </h2>
        <p class="text-gray-500">
          Sini-Saja membantu mengelola & memantau perkembangan kegiatan
          kontraktor
        </p>
        <v-row class="mt-5">
          <v-col cols="6">
            <table
              class="table w-100 rounded table-borderless"
              style="overflow: hidden; font-family: 'Inter-Regular', serif"
            >
              <thead class="font-inter text-[#28293d] font-normal">
                <tr class="table-danger" style="max-height: 5vh">
                  <th class="p-2 text-nowrap text-sm" style="width: 30%">
                    Status
                  </th>
                  <th class="p-2 text-nowrap text-sm" style="width: 70%">
                    Keterangan
                  </th>
                </tr>
              </thead>
              <tbody class="text-xs">
                <tr v-for="(data, index) in listStatus" :key="index">
                  <td
                    class="align-items-center"
                    :class="{ 'table-secondary': index % 2 == 1 }"
                  >
                    <span
                      class="p-1 rounded-md text-white mx-auto"
                      :style="`background-color: ${data.color};`"
                    >
                      {{ data.name }}
                    </span>
                  </td>
                  <td :class="{ 'table-secondary': index % 2 == 1 }">
                    {{ data.description }}
                  </td>
                </tr>
              </tbody>
            </table>
          </v-col>
          <v-col cols="12" class="bg-white rounded-lg p-3 shadow-md">
            <div class="w-1/2 flex gap-3 items-center">
              <v-text-field
                variant="outlined"
                density="compact"
                color="red"
                hide-details
                clearable
                v-model="formValues.kontraktorName"
                v-on:keyup.enter="cariKontraktor"
                prepend-inner-icon="mdi-magnify"
                placeholder="Masukkan Nama Kontraktor"
              ></v-text-field>
              <v-btn
                class="bg-red-600 text-white capitalize"
                @click="refreshPage()"
              >
                Refresh Filter
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <div class="mt-8 rounded-lg shadow-md overflow-x-auto w-full">
        <v-data-table-server
          v-model:items-per-page="dataTable.pagination.itemsPerPage"
          :items-per-page-options="[5, 10, 25, 50, 100]"
          :headers="dataTable.headers"
          :items="dataTable.items"
          :items-length="dataTable.pagination.totalItems"
          @update:options="getListSio"
        >
          <template v-slot:item="{ item, index }">
            <tr
              class="border-b border-gray-950 h-16"
              :class="{ 'bg-gray-50': index % 2 !== 0 }"
            >
              <td>{{ getIndex(index) }}</td>
              <td>{{ item.namaKontraktor }}</td>
              <td>{{ item.namaPjo }}</td>
              <td>
                {{ moment(item.tanggalPengajuan).format("DD/MMM/YYYY") }}
              </td>
              <td>
                <div
                  v-if="listStatus.some((data) => data.status == item.status)"
                >
                  <span
                    v-for="data in listStatus.filter(
                      (data) => data.status == item.status
                    )"
                    :key="data.id"
                    class="badge"
                    style="color: #f2f0f0"
                    :style="{ 'background-color': data.color }"
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-circle"
                      style="
                        font-size: 0.5em;
                        margin-bottom: 0.25em;
                        color: #f2f0f0;
                      "
                    />
                    {{ data.name }}
                  </span>
                </div>
              </td>
              <td
                class="text-center flex justify-between items-center border-b-0 w-full"
              >
                <a
                  class="text-danger fw-bolder pointer"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Lihat Dokumen"
                  style="text-decoration: none"
                  @click="lihatDokumen(item.idSio, item.kontraktorId)"
                >
                  <img
                    src="../../assets/icons/lihat_dokumen_sio.png"
                    alt=""
                    class="w-5 h-auto"
                  />
                </a>
                <a
                  class="text-danger fw-bolder pointer"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Lihat Kontraktor"
                  style="text-decoration: none"
                  @click="
                    redirectToLink(
                      '/profileKontraktorPreview/',
                      item.kontraktorId
                    )
                  "
                >
                  <font-awesome-icon icon="fa-solid fa-building" />
                </a>
              </td>
            </tr>
          </template>
        </v-data-table-server>
      </div>
    </v-row>
  </DefaultLayout>
</template>

<style scoped>
.btn_lihat_dokumen {
  background: #ffffff !important;
  color: #dd3737 !important;
}
</style>

<script>
// import SidebarComponent from "@/components/SideBar.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import MasterDataStatus from "@/data/status.json";
import GlobalDataMixin from "../../GlobalDataMixin";
import { API_BASE_URL, CMS_SIO_LIST } from "../../constants.js";
import axios from "axios";
import router from "@/router";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import {
  CreateDataTableObject,
  SetDataTableResponse,
} from "@/utilities/DataTableHelpers";

const url_list_sio = API_BASE_URL + CMS_SIO_LIST;

export default {
  mixins: [GlobalDataMixin],
  name: "ReportSioPage",
  components: {
    FontAwesomeIcon,
    DefaultLayout,
  },
  data() {
    return {
      dataTable: CreateDataTableObject([
        { title: "No.", align: "start", sortable: false, width: "5%" },
        {
          title: "Nama Kontraktor",
          align: "start",
          sortable: false,
          width: "35%",
        },
        { title: "Nama PJO", align: "start", sortable: false, width: "15%" },
        {
          title: "Tanggal Pengajuan",
          align: "start",
          sortable: false,
          width: "15%",
        },
        { title: "Status", align: "start", sortable: false, width: "15%" },
        { title: "Action", align: "center", sortable: false, width: "15%" },
      ]),
      // detailsOpen: [],
      isLoadingJadwal: [],
      dataJadwal: [],
      dataHistory: [],
      dataSio: [],
      currentPage: 1,
      perPage: 5,
      totalData: 0,
      formValues: {
        perPage: 5,
        kontraktorName: null,
      },
      filtersInitialized: false,
      tableDetailOpen: [],
      type: null,
      listStatus: [],
    };
  },
  mounted() {
    this.type = this.determineType(this.$route.path);
    this.listStatus = MasterDataStatus.filter((item) =>
      item.type.includes(this.type)
    );
    this.initFiltersFromQuery();
    this.filtersInitialized = true;
    this.getListSio();
  },
  activated() {
    if (this.filtersInitialized) {
      this.initFiltersFromQuery();
      this.getListSio();
    }
  },

  watch: {
    $route(to) {
      this.type = this.determineType(to.path);
      this.initFiltersFromQuery();
      this.getListSio();
    },
  },
  beforeRouteUpdate(to, _, next) {
    this.type = this.determineType(to.path);
    next();
  },
  methods: {
    determineType(path) {
      if (path === "/pengajuan-baru-report") return 1;
      if (path === "/pergantian-sio-report") return 2;
      if (path === "/update-data-report") return 3;
      return null;
    },
    initFiltersFromQuery() {
      const q = this.$route.query;
      this.formValues.kontraktorName = q.kontraktorName ?? "";
      if (q.page !== undefined && q.page !== "") {
        this.currentPage = Number(q.page);
        this.dataTable.pagination.page = Number(q.page);
      }
      if (q.perPage !== undefined && q.perPage !== "") {
        this.formValues.perPage = Number(q.perPage);
        this.dataTable.pagination.itemsPerPage = Number(q.perPage);
      }
    },
    syncFiltersToUrl() {
      const query = {
        kontraktorName: this.formValues.kontraktorName || undefined,
        page: this.currentPage > 1 ? this.currentPage : undefined,
        perPage:
          this.formValues.perPage !== 5 ? this.formValues.perPage : undefined,
      };
      this.$router.replace({ query }).catch(() => {});
    },
    buildSioQuery() {
      const q = {};
      if (this.formValues.kontraktorName)
        q.kontraktorName = this.formValues.kontraktorName;
      if (this.currentPage > 1) q.page = this.currentPage;
      if (this.formValues.perPage !== 5) q.perPage = this.formValues.perPage;
      return q;
    },
    getListSio({ page, itemsPerPage } = {}) {
      if (page) {
        this.currentPage = page;
      }
      if (itemsPerPage) {
        this.formValues.perPage = itemsPerPage;
      }
      this.syncFiltersToUrl();
      let bodyJsonProfile = {
        page: this.currentPage,
        perPage: this.formValues.perPage,
        nama: this.formValues.kontraktorName,
        type: this.type,
      };
      axios
        .post(url_list_sio, bodyJsonProfile, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          this.dataSio = response.data.data;
          this.totalData = response.data.total;

          let result = {};
          result.data = response.data.data;
          result.total_data = response.data.total;
          result.total_per_page = this.formValues.perPage;
          result.current_page = this.currentPage;
          this.dataTable = SetDataTableResponse(this.dataTable, result);
        })
        .catch((error) => {
          console.log("error setSioID : ", error);
          alert("error setSioID");
        })
        .then(() => {});
    },
    preventSubmit() {
      console.log("prevent submit");
    },
    refreshPage() {
      this.formValues.kontraktorName = "";
      this.currentPage = 1;
      this.dataTable.pagination.page = 1;
      this.syncFiltersToUrl();
      this.getListSio();
    },
    lihatDokumen(idsio, kontraktorId) {
      this.$router.push({
        path: "/dokumenpersyaratanpengajuanpjo/" + idsio + "/" + kontraktorId,
        query: this.buildSioQuery(),
      });
    },
    lihatSuratPengesahan(idSio, kontraktorId) {
      this.$router.push({
        path: "/approval-sio/surat-pengesahan/" + idSio + "/" + kontraktorId,
        query: this.buildSioQuery(),
      });
    },
    lihatDokumenSIO(idsio, kontraktorId) {
      this.$router.push({
        path: "/lihatDokumenSIO/" + idsio + "/" + kontraktorId,
        query: this.buildSioQuery(),
      });
    },
    resetPaginasi() {
      this.dataSio = [];
      this.tableDetailOpen = [];
      this.formValues.perPage = 5;
      this.currentPage = 1;
      this.totalData = 0;
    },
    cariKontraktor() {
      this.tableDetailOpen = [];
      this.resetPaginasi();
      this.getListSio();
    },
    changePage(num) {
      this.tableDetailOpen = [];
      let cp = this.currentPage + num;
      if (
        !(num == -1 && this.currentPage == 1) &&
        cp * this.formValues.perPage <=
          this.totalData + (this.formValues.perPage - 1)
      ) {
        this.currentPage = this.currentPage + num;
        this.getListSio();
      }
    },
    changePerPage() {
      this.currentPage = 1;
      this.tableDetailOpen = [];

      this.getListSio();
    },
    getIndex(index) {
      return index + (this.currentPage - 1) * this.perPage + 1;
    },
    redirectToLink(link, id) {
      router.push({
        path: link + id,
        query: this.buildSioQuery(),
      });
    },
  },
};
</script>

<style scoped>
section {
  font-family: "Inter", sans-serif;
  font-style: normal;
  min-height: 100vh;
}
:deep(thead) {
  background-color: #fecaca;
}
</style>
